export default "__VITE_ASSET__DuhlnMeB__"